// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Product+Details+API
const SkuUtils = require('../../../utils/Sku');
const ufeApi = require('../../api/ufeApi');
const urlUtils = require('../../../utils/Url');
const { userXTimestampHeader } = require('utils/Headers');


const addCurrentSkuToProductChildSkus = productData => {
    const {
        regularChildSkus = [],
        onSaleChildSkus = [],
        currentSku = {}
    } = productData;
    const skuIdComparer = ({ skuId }) => skuId === currentSku.skuId;

    if (currentSku.salePrice) {
        if (!onSaleChildSkus.some(skuIdComparer)) {
            onSaleChildSkus.unshift(currentSku);
        }
    } else {
        if (!regularChildSkus.some(skuIdComparer)) {
            regularChildSkus.unshift(currentSku);
        }
    }

    productData.regularChildSkus = regularChildSkus;
    productData.onSaleChildSkus = onSaleChildSkus;

    return productData;
};

const changeCurrentSkuTo = (product, skuId) => {
    if (!skuId) {
        return;
    }

    const sku = SkuUtils.getSkuFromProduct(product, skuId);

    if (sku) {
        product.currentSku = sku;
    }
};

const getProductDetails = (productId, skuId = null, options = {}, config = {}) => {
    let url = `/api2/catalog/products/${productId}`;

    if (skuId) {
        options.includeConfigurableSku = true;
    }

    if (skuId || Object.keys(options).length) {
        url += `?${urlUtils.makeQueryString(options)}`;
    }

    const requestOptions = options.removePersonalizedData ? { headers: { EXCLUDE_PERSONALIZED_CONTENT: true } } : {};

    if (config.includeTimestamp) {
        requestOptions.headers = {
            ...(requestOptions.headers || {}),
            ...userXTimestampHeader()
        };

        delete config.includeTimestamp;
    }

    return ufeApi.makeRequest(url, requestOptions, config)
        .then(data => data.errorCode ? Promise.reject(data) : (() => {
            let product = data;

            if (options.addCurrentSkuToProductChildSkus) {
                product = addCurrentSkuToProductChildSkus(product);
            }

            changeCurrentSkuTo(product, skuId);

            return Promise.resolve(product);
        })());
};

module.exports = getProductDetails;
